import React from "react"

import { ProjectPageFloorSidebar } from "pages/project-page/sidebar/floor/ProjectPageFloorSidebar"
import {
  UseSharedProjectPageFloorSidebarModelArgs,
  useSharedProjectPageFloorSidebarModel
} from "pages/project-page/sidebar/floor/hooks/useSharedProjectPageFloorSidebarModel"

export const SharedProjectPageFloorSidebarConnector = React.memo(
  (props: UseSharedProjectPageFloorSidebarModelArgs) => (
    <ProjectPageFloorSidebar
      id="floor-sidebar-form"
      {...useSharedProjectPageFloorSidebarModel(props)}
      hideControls
    />
  )
)
